import { observable, action, useStrict, computed, runInAction, autorun, flow } from 'mobx';
import _ from 'lodash';
import { Toast } from 'antd-mobile';
import Stores from 'config/Stores';
import Serv from './OrderSwitchServ';

// 前后端字段映射
const fieldMap = {
  allOrder: '',
  payOrder: 'INIT',
  outOrder: 'WAIT_DELIVERY',
  putOrder: 'DELIVERY',
  finishOrder: 'SUCC',
  cancelOrder: 'CANCEL'
};

let emptyContainer = {
  // 配合pullrefresh, loading做到避免重复获取同一页的问题
  period: '',
  loading: false,
  pageNum: 0,
  list: [],
  end: false
};

/* 根据需求，要做到数据常驻内存，而非每次切换tab都重新刷新，因此需要给每个tab一个单独的变量容器 */
class OrderSwitchMod {
  // 1 是会员 2 是店铺
  @observable orderType = 1;

  // 当前处于激活的tab索引
  @observable curTabPage = 0;

  // 每页数量
  @observable pageSize = 10;

  // 当前订单
  @observable current = _.cloneDeep(emptyContainer);

  // 未调期
  @observable future = _.cloneDeep(emptyContainer);

  // 已调期
  @observable already = _.cloneDeep(emptyContainer);

  // 订单最近期数
  @observable recentPeriod = [];

  @observable period = '';

  /**
   * 修改参数逻辑
   */
  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  @computed
  get recentPeriodText() {
    let text = '';
    let type = ['current', 'future', 'already'][this.curTabPage];
    for (let i = 0; i < this.recentPeriod.length; i++) {
      if (`${this[type].period}` == this.recentPeriod[i].value) {
        text = this.recentPeriod[i].label;
        break;
      }
    }
    return text;
  }

  @action
  onPeriodPick(value, type) {
    if (this[type].period === value[0]) return;
    this[type].period = value[0];
    this.getOrderList(type, { isReload: true });
  }

  /**
   * 获取某种订单类型列表的下一页
   * @param {String} type - 订单类型
   * @param {object} extend - 扩展参数 isReload为是否重新加载
   */
  getOrderList = flow(function* (type, extend = { isReload: false }) {
    try {
      if (extend.isReload) {
        this[type].pageNum = 0;
        this[type].list = [];
        this[type].end = false;
      }
      if (this[type].loading || (this[type].end && !extend.isReload)) return;
      this[type].loading = true;

      // 店铺id，H5只有店铺调期的入口，故默认都加上shopId
      const { id } = Stores.AppMod.storeInfo || {};

      let params = {
        pageNum: this[type].pageNum + 1,
        pageSize: this.pageSize,
        periodBeginTime: this[type].period,
        periodEndTime: this[type].period,
        shopId: id
      };
      if (+this.curTabPage) {
        params.periodsStatus = ['', 'INIT', 'SUCC'][+this.curTabPage];
      }
      params = Object.assign(params, extend);
      const { data } = yield Serv.getOrderList(params);
      this[type].loading = false;
      if (data.list && data.list.length) {
        this[type].list = this[type].list.concat(data.list);
        this[type].pageNum = this[type].pageNum + 1;
      }
      this[type].end = this.pageSize * this[type].pageNum >= data.total;
    } catch (error) {
      this[type].loading = false;
    }
  });

  /**
   * 查询期数列表
   */
  getPeriodList = flow(function* (queryNum) {
    try {
      const { data } = yield Serv.getPeriodList(queryNum);
      let pickerList = [];
      if (Array.isArray) {
        data.map((item) => {
          if (item.startTime && item.endTime) {
            let label = `${item.period}期(${item.startTime.substr(0, 10).replace(/-/g, '.')} ~ ${item.endTime.substr(0, 10).replace(/-/g, '.')})`;
            pickerList.push({ value: item.period, settlementStatus: item.settlementStatus, label });
          }
        });
        this.recentPeriod = pickerList || []; // Picker展示的数据
        this.current.period = data[0].period;
        this.future.period = data[0].period;
        this.already.period = data[0].period;
        this.getOrderList('current');
      }
    } catch (error) {}
  });

  /**
   * 申请调期
   * @param {String} tradeNo - 订单编号
   * @param {String} period - 需要调的目标期数
   * @param {String} tradtypeeNo - 身份: 1-会员身份、2-店铺身份
   */
  applySwitch = flow(function* (tradeNo, period, type) {
    try {
      const { id } = Stores.AppMod.storeInfo || {};
      let params = {
        tradeNo,
        periods: period
      };
      if (type == 2) {
        params.shopId = id;
      }
      yield Serv.appySwitch(params);
      Toast.info('申请成功~', 1, () => {
        window.app.router.goBack();
      });
    } catch (error) {}
  });
}

const orderSwitchMod = new OrderSwitchMod();
export default orderSwitchMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/TradeManage/OrderSwitch/OrderSwitchMod.js